export const stagingDomain = 'app-resident-datahub-web-prod-staging.azurewebsites.net';
